import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import ListCard, {
  ListCardNotDeduction,
  ListCardNotSetDeduction,
} from '../../../components/ListCard';
import Typography from '../../../components/common/Typography';
import { formatNumber, nameRelation } from '../../../common/Util';
import { useTranslation } from 'react-i18next';
import {
  getInsuranceInfo,
  resetInsuranceState,
  setSelectedInsuranceDetail,
} from './insuranceSlice';
import { relationOptions } from '../../../common/data';

// 이름 : v.htm038
// 관계 : familyCode[v.htm002]
// 주민등록번호 : v.htm001
// 보험료(일반) 국세청 : v.htm016
// 보험료(장애) 국세청 : v.htm017
// 보험료(일반) 국세청외 : v.htm018
// 보험료(장애) 국세청외 : v.htm019
const InsuranceItemSection = ({ onOpen }) => {
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const { dataList, isRender, reload } = useSelector(state => state.insurance);
  const { t: tDependents } = useTranslation('dependents');

  const relationList = relationOptions(tDependents);

  //초기 데이터 호출
  useEffect(() => {
    dispatch(getInsuranceInfo());
  }, []);

  //저장, 삭제시 재호출
  useEffect(() => {
    if (reload != -1) {
      dispatch(getInsuranceInfo());
    }
  }, [reload]);

  //언마운트시 초기화
  useEffect(() => {
    return () => {
      dispatch(resetInsuranceState());
    };
  }, [dispatch]);

  const handleClick = data => {
    if (data?.htm001) {
      dispatch(setSelectedInsuranceDetail({ htm001: data?.htm001 }));
      onOpen();
    }
  };

  const content = (data, index, title) => {
    if (data.deType == '1') {
      return (
        <ListCard
          key={index}
          onClick={() => handleClick(data)}
          content={<ListCardContent data={data} title={title} />}
          isFirst={index === 0}
          title="보험료"
        />
      );
    }
    if (data.deType == '2') {
      return <ListCardNotDeduction title={title} key={index} />;
    }

    return <ListCardNotSetDeduction title={title} key={index} />;
  };

  return (
    <div>
      {dataList?.map((data, index) => {
        // 이름 (관계)
        let title = nameRelation(tDependents, data);
        return content(data, index, title);
      })}
    </div>
  );
};

export default InsuranceItemSection;

const ListCardContent = ({ data, title }) => {
  const { t } = useTranslation('deductions/insurance');

  const documentItem = () => {
    if (Number(data?.htm018 || 0) > 0 || Number(data?.htm019 || 0) > 0) {
      //납입증명서
      return t('card.item4');
    } else {
      //불필요
      return t('card.item3');
    }
  };

  //item1 : 일반, item2 : 장애
  return (
    <div>
      <Typography variant="body2Bold">{title}</Typography>
      <Typography variant="captionMedium">
        {t('card.itemTitle1')} {t('card.item1')}: {formatNumber(data?.htm016 || 0)}원 /{' '}
        {t('card.item2')} : {formatNumber(data?.htm017 || 0)} {t('card.price')}
      </Typography>
      <Typography variant="captionMedium" color="Primary-500">
        {t('card.itemTitle2')} {t('card.item1')}: {formatNumber(data?.htm018 || 0)}원 /{' '}
        {t('card.item2')} : {formatNumber(data?.htm019 || 0)} {t('card.price')}
      </Typography>
      <Typography variant="captionMedium">
        {t('card.itemTitle3')} : {documentItem()}
      </Typography>
    </div>
  );
};
